import React, { memo } from 'react';
import { Button, IconTrash2 } from '@seekube-tech/ui-kit';
import { useFormatMessage } from 'react-intl-hooks';
import { getEventPhases, isEventInPreregistration } from '@/store/availableActions/utils/event';

const Actions = ({ event, selectedEvents, onClick }) => {
  const t = useFormatMessage();
  const eventPhases = getEventPhases(event);
  const isPreregistrationPhase = isEventInPreregistration(eventPhases);

  function onButtonClick() {
    onClick(event._id)
  }

  return (
    selectedEvents.includes(event._id) ?
      <Button
        className="w-full"
        variant="tonal"
        color="error"
        imageComponentLeft={<IconTrash2 size={16} />}
        onClick={onButtonClick}>
        {isPreregistrationPhase ? t({ id: 'cancel.preregistration.cta' }) : t({ id: 'cancel.signin.signup' })}
      </Button> :
      <Button
        className="w-full"
        onClick={onButtonClick}>
        {isPreregistrationPhase ? t({ id: 'preregistration.cta' }) : t({ id: 'signin.signup' })}
      </Button>
  )
}
export default memo(Actions);
